import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast, { Toaster } from "react-hot-toast";

import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "./api";

import { Per_Page_Dropdown, Select2Data, RegxExpression } from "./common";

export const Context = createContext();

const AppContext = ({ children }) => {
  // const IMG_URL = "http://127.0.0.1:1515";
  // const IMG_URL = "http://127.0.0.1:1515";
  const IMG_URL = "https://stoxwave-node.onrender.com";
  const SOCKET = "https://stoxwave-node.onrender.com";
  // const IMG_URL = "https://stockwave-node.profcyma.org:1517";
  // const SOCKET = "https://stockwave-node.profcyma.org:1517";

  const navigate = useNavigate();

  const [signin, setSignin] = useState(false);
  // const [language, setLanguage] = useState(1);
  const [usertype, setUsertype] = useState("");
  const [variant, setVariant] = useState("");
  const [userdata, setUserData] = useState("");
  const [isAllow, setisAllow] = useState([]);
  const [wishlistData, setWishlistData] = useState([]);
  const [addCartModal, setAddCartModal] = useState(false);
  const [shimmerLoader, setShimmerLoader] = useState(false);
  const [signinGoogle, setSigninGoogle] = useState(false);
  const [buyOrSale, setBuyOrSale] = useState("buy");

  const [appSetUpData, setAppSetUpData] = useState({});
  const [headerCompanyName, setHeaderCompanyName] = useState("");

  const minLength = 2;

  const maxLength = 30;

  const [taxRupees, setTaxRupees] = useState("");

  const [reactLoader, setReactLoader] = useState(false);

  const isTokenValid = async () => {
    const token = Cookies.get("stoxwave_security");

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = JSON.parse(atob(token.split(".")[1]));


      const currentTime = Date.now() / 1000;

      // Check if the token has expired
      if (decodedToken.exp < currentTime) {
        await Cookies.remove("stoxwave_security", { path: "/" });
        setSignin(false);
        setUsertype("");
        setisAllow([]);
        navigate("/");
      } else {
        setisAllow(decodedToken?.permissions);
        getuserData(decodedToken.user);
        setUsertype(decodedToken.rolename);
        getAppsetUpData();

        setSignin(true);
      }
    } else {
      setisAllow([]);
      setSignin(false);
      setUsertype("");
      // navigate("/");
    }
  };

  useEffect(() => {
    isTokenValid();
  }, [signin]);

  const [cartCount, setCartCount] = useState(0);
  const [trigger, setTrigger] = useState(0);

  const triggerCartUpdate = () => {
    setTrigger(trigger === 0 ? 1 : 0);
  };

  const getuserData = async (id) => {
    const response = await getData(`/common/auth/admin-login/${id}`, {
      id: id,
    });


    await setUserData(response?.data);
  };

  const getAppsetUpData = async (id) => {
    const response = await getData(`/common/masters/app-setup`);

    await setAppSetUpData(response?.data);
  };

  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const user = urlParams.get("user");

    if (token && user) {
      Cookies.set("stoxwave_security", token, {
        expires: 1,
      });
      setSignin(true);

      // Display the user information in the frontend
    } else {
      console.log("Login failed or missing token");
    }
  }, [signinGoogle]);

  // Togle
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  return (
    <Context.Provider
      value={{
        IMG_URL,
        SOCKET,
        getData,
        postData,
        putData,
        deleteData,
        minLength,
        maxLength,
        signin,
        setSignin,
        usertype,
        setUsertype,
        userdata,
        setUserData,
        getDownloadDataExcel,
        ErrorNotify,
        variant,
        setVariant,
        // token,
        // setToken,
        toggleSidebar,
        isSidebarOpen,
        setSidebarOpen,
        Select2Data,
        Per_Page_Dropdown,
        RegxExpression,
        shimmerLoader,
        setShimmerLoader,
        addCartModal,
        setAddCartModal,
        cartCount,
        triggerCartUpdate,
        wishlistData,
        setWishlistData,

        setSigninGoogle,
        signinGoogle,
        getuserData,
        taxRupees,
        setTaxRupees,
        reactLoader,
        setReactLoader,
        setBuyOrSale,
        buyOrSale,
        getAppsetUpData,
        appSetUpData,
        setHeaderCompanyName,
        headerCompanyName,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
